export const ButtonField = ({
  children,
  className = "d-flex align-items-center my-3 col-12 col-lg-10 col-xl-12 p-0",
}) => {
  return <div className={className}>{children}</div>
}
